// Credit cost for TTS synthesis. Mirrors the avatar billing flow: post-pay, fractional value
// in the payload, allowed to push the user balance below zero. Microsoft (standard) voices are
// free. only Gemini (advanced) voices are billable.
//
// Rate: 1 minute = 30 credits, 1 credit = 2 seconds, 0.5 credits/sec.
// The boutique counter stores the credits as double, per-user "int" balance truncates on subtraction
// (same behaviour as avatars, not fixed here).

import { getProviderForVoice } from "@/store/media/ttsCatalogModel";

const GEMINI_TTS_CREDITS_PER_SECOND = 0.5;

/** Credits a TTS generation of "seconds" costs for the given voice. 0 = not billable. */
export const ttsCreditsForVoice = (voiceId: string, seconds: number): number => {
    if (!voiceId || !(seconds > 0)) return 0;
    if (getProviderForVoice(voiceId) !== "GEMINI") return 0;
    return seconds * GEMINI_TTS_CREDITS_PER_SECOND;
};
